import React from "react";
import { Link } from "react-router-dom";
import OwnPropertyNotice from "../components/OwnPropertyNotice";

const BusinessContent = () => {
  return (
    <div className="container mx-auto py-16 px-4">
      
      {/* 事業内容 タイトル */}
      <div className="text-center mb-16">
        <h1 className="text-3xl font-bold text-gray-800">事業内容</h1>
        <img src="/images/image4.png" alt="装飾ライン" className="mx-auto my-2 w-32" />
      </div>

      {/* 事業内容のセクション */}
      <div className="flex flex-col md:flex-row justify-center items-center text-center space-y-8 md:space-y-0 md:space-x-16">
        {/* 民泊運営事業 */}
        <Link to="/businessContent/minpaku" className="text-center">
          <button className="w-80 h-32 border-4 border-primary text-primary font-bold text-4xl rounded-lg transition-transform transform hover:scale-105 hover:bg-primary hover:text-white">
            民泊運営事業
          </button>
        </Link>

        {/* 不動産事業 */}
        <Link to="/businessContent/real-estate" className="text-center">
          <button className="w-80 h-32 border-4 border-primary text-primary font-bold text-4xl rounded-lg transition-transform transform hover:scale-105 hover:bg-primary hover:text-white">
            不動産事業
          </button>
        </Link>
      </div>

      <OwnPropertyNotice className="mt-12" />
    </div>
  );
};

export default BusinessContent;
